import { render, staticRenderFns } from "./BirdDogReferralsTable.vue?vue&type=template&id=54743920&scoped=true&"
import script from "./BirdDogReferralsTable.vue?vue&type=script&lang=js&"
export * from "./BirdDogReferralsTable.vue?vue&type=script&lang=js&"
import style0 from "./BirdDogReferralsTable.vue?vue&type=style&index=0&id=54743920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54743920",
  null
  
)

export default component.exports